import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { getShopify } from './lib/app-bridge';
import './index.css';

// Configure App Bridge API key early, before React renders
// This ensures the meta tag is set so App Bridge can read it
getShopify();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

